module.exports = __webpack_public_path__ + "img/ticket.ddcc75ce.jpg";